import React, { useContext, useEffect } from "react";
import Interior from "../../../components/Admin/Blog/index.jsx";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import DatePicker from "../../../components/common/DatePicker/index.jsx";
import Blogs from "../../../components/Admin/Blog/index.jsx";
import AppContext from "../../../AppContext";

const pathPrefix = "/admin/blog";

const AdminBlogPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <AdminLayout title={"Blog"}>
      <Routes>
        <Route path="/" element={<Blogs />} />
        {/*<Route path="/interior" element={<Blogs category={"interior"}/>}/>*/}
        {/*<Route path="/photographer" element={<Blogs category={"photographer"}/>}/>*/}
        {/*<Route path="/landscape" element={<Blogs category={"landscape"}/>}/>*/}
        {/*<Route path="/architecture" element={<Blogs category={"architecture"}/>}/>*/}
      </Routes>
    </AdminLayout>
  );
};

AdminBlogPage.propTypes = {};

export default AdminBlogPage;
